<template>
  <div id="topbar">
    <div class="wrap" id="top">
      <img id="logo" src="./img/logo.png">
      <router-link to="/login" class="navBut navBut01">申请试用</router-link>
      <div class="navBut navBut02" @click="clickToMan">用户登录</div>
      <router-link to="/joinUs" class="navList" :class="{navListOn: text === '加入我们'}">加入我们</router-link>
      <router-link to="/aboutUs" class="navList" :class="{navListOn: text === '关于我们'}">关于我们</router-link>
      <router-link to="/solution" class="navList" :class="{navListOn: text === '解决方案'}">解决方案</router-link>
      <router-link to="/productsCenter" class="navList" :class="{navListOn: text === '产品中心'}">产品中心</router-link>
      <router-link to="/" class="navList" :class="{navListOn: text === '首页'}" id="navListOn">首页</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Topbar',
  props: {
    imp: {
      type: Object,
      default: function () {
        return {
          text: ''
        }
      }
    }
  },
  data () {
    return {
      text: this.imp.text
    }
  },
  methods: {
    clickToMan: function () {
      window.open('https://wl.hang-shu.com')
    }
  }
}
</script>
<style scoped>
#top{ height: 70px;}
#logo{ width: 132px; height: 43px; margin-top: 13px;}
.navBut{ display: block; width: 100px; height: 28px; float: right; margin: 21px 0 0 16px; font-size: 16px; line-height: 28px;
 color: #fffeff; text-align: center; border-radius: 3px;}
.navBut01{ background: #009944;}
.navBut02{ background: #00a0e9;}
.navList{ width: auto; height: 39px; font-size: 16px; color: #444; float: right;
 margin: 21px 20px 0; line-height: 28px;}
.navList:hover,.navListOn{ color: #0f376b; border-bottom: #0f376b solid 4px;}
.navListOn{ font-weight: bold;}
</style>



// WEBPACK FOOTER //
// src/components/base/Topbar/index.vue